import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4dc9c41c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "py-2 px-3 flex flex-col messaging-content" };
const _hoisted_2 = { class: "flex flex-row gap-2 text-gray-400" };
import { UICollapse, UICollapseItem, UIDivider, UITextXsRegular, } from '@gohighlevel/ghl-ui';
import AcknowledgementMessage from './Messaging/AcknowledgementMessage.vue';
import Language from './Messaging/Language.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Messaging',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(UITextXsRegular), null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('sidebar.messagingHelper')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(_unref(UIDivider)),
                _createVNode(_unref(UICollapse), {
                    arrowPlacement: 'left',
                    displayDirective: 'if'
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(UICollapseItem), {
                            title: _ctx.$t('sidebar.acknowledgement'),
                            name: "1",
                            id: "1"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(AcknowledgementMessage)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["title"]),
                        _createVNode(_unref(UICollapseItem), {
                            title: _ctx.$t('sidebar.language'),
                            name: "2",
                            id: "2"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(Language)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["title"])
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
